import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RestFilledSvg from "@ant-design/icons-svg/es/asn/RestFilled";
import AntdIcon from '../components/AntdIcon';
var RestFilled = function RestFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: RestFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(RestFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'RestFilled';
}
export default RefIcon;